const IS_PRODUCTION = process.env.NODE_ENV === "production";

/**
 * Web analytics event'lerinin gonderildigi adres.
 * beta/prod: API GW -> Lambda -> Kafka (supsis servisleri down olsa bile yazma calisir).
 * local: API GW + Lambda + Kafka bypass edilir, tablet public endpoint'i dogrudan isler.
 */
const TRACK_URL = IS_PRODUCTION
    ? process.env.ENVIRONMENT === "stage"
        ? "https://webhook.supsis.ai/beta/web-analytics"
        : "https://webhook.supsis.ai/prod/web-analytics"
    : process.env.TABLET_URL + "public/web-analytics/collect";

/**
 * Sayfa kayit defteri / AI analizi icin sayfa govdesi adresi.
 * Ayri endpoint ve ayri Kafka topic'i kullanilir: sayfa govdeleri event batch'inin
 * 64 KB sendBeacon kotasina sigmaz ve agir islem event akisini geciktirmemelidir.
 */
const TRACK_PAGE_URL = IS_PRODUCTION
    ? process.env.ENVIRONMENT === "stage"
        ? "https://webhook.supsis.ai/beta/web-analytics/page"
        : "https://webhook.supsis.ai/prod/web-analytics/page"
    : process.env.TABLET_URL + "public/web-analytics/page-collect";

export const CONFIG = {
    isProd: IS_PRODUCTION,
    isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    IS_STAGE: process.env.ENVIRONMENT === "stage",
    TRACK_URL: TRACK_URL,
    TRACK_PAGE_URL: TRACK_PAGE_URL,
    AKINON_ENABLED: (url) => {
        try {
            const hostname = new URL(url).hostname;
            return ["localsite.supsis.live"].some((x) =>
                hostname.includes(x)
            );
        } catch (e) {
            return false;
        }
    },
    CHATBOT_NAMES: {
        default: "Chatbot Asistan",
    },
    CHATBOT_IMAGES: {
        default: null,
    },


};



// WEBPACK FOOTER //
// ./src/utils/config.js